export default __webpack_public_path__ + "media/health.30597846.svg";